(function () {
  var box = document.getElementById('onr-diag-mailbox'); if (!box) return;
  var form = box.querySelector('form'); if (!form) return;
  var tagsInput = form.querySelector('[name="contact[tags]"]');
  var done = box.querySelector('[data-mail-done]');
  var btn = form.querySelector('button[type=submit]');
  function success() { form.style.display = 'none'; done.style.display = 'block'; }
  document.addEventListener('onr:diag-result', function (e) {
    tagsInput.value = (e.detail && e.detail.tags || []).join(',');
    try { sessionStorage.setItem('onrDiagTags', tagsInput.value); } catch (x) {}
    form.style.display = ''; done.style.display = 'none';
  });
  if (/customer_posted=true/.test(location.search) || /form_type=customer/.test(location.search)) {
    var b = document.getElementById('onr-diag-posted'); if (b) b.style.display = 'block';
  }
  form.addEventListener('submit', function (ev) {
    var email = form.querySelector('[type=email]');
    if (!email.value || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value)) { return; }
    ev.preventDefault();
    btn.disabled = true; var t = btn.textContent; btn.textContent = 'Envoi…';
    fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
      .then(function (r) {
        if (/challenge/.test(r.url)) { form.submit(); return; }
        success();
      })
      .catch(function () { form.submit(); })
      .finally(function () { btn.disabled = false; btn.textContent = t; });
  });
})();
